// vs-comparison 编辑器：左右 name + stats(label/value) 增删。
import { useTranslation } from 'react-i18next'
import type { EditorContext } from '../_shared/types'
import type { VsData } from './types'
import { Field, TextInput, Repeater, RemoveButton } from '../../components/editor-controls'

export function VsComparisonEditor({ data, update }: EditorContext) {
  const { t } = useTranslation()
  const d = data as unknown as VsData
  const renderSide = (side: 'left' | 'right', label: string) => {
    const s = d[side]
    return (
      <Field label={label}>
        <TextInput
          value={s?.name ?? ''}
          placeholder={t('editor.namePh')}
          onChange={(v) => update((dd) => { dd[side].name = v })}
        />
        {(s?.stats || []).map((st, i) => (
          <div className="editable-item" key={i}>
            <TextInput
              value={st.label}
              placeholder={t('editor.metricPh')}
              style={{ flex: 1 }}
              onChange={(v) => update((dd) => { dd[side].stats[i].label = v })}
            />
            <TextInput
              value={st.value}
              placeholder={t('editor.valuePh')}
              style={{ flex: 1 }}
              onChange={(v) => update((dd) => { dd[side].stats[i].value = v })}
            />
            <RemoveButton onRemove={() => update((dd) => { dd[side].stats.splice(i, 1) })} />
          </div>
        ))}
        <Repeater addLabel={t('editor.metric')} onAdd={() => update((dd) => { dd[side].stats.push({ label: '', value: '' }) })} />
      </Field>
    )
  }
  return (
    <>
      <Field label={t('editor.title')}>
        <TextInput value={d.title ?? ''} onChange={(v) => update((dd) => { dd.title = v })} />
      </Field>
      {renderSide('left', t('editor.left'))}
      {renderSide('right', t('editor.right'))}
    </>
  )
}
